// src/hooks/useFetch.js
import { useState, useEffect } from 'react';
import { getData } from '../api/apiService';
import { useStateContext } from '../contexts/ContextProvider';

export const useFetch = (endpoint, queryParams, initialData = []) => {
	const { currentDept } = useStateContext();
	const [data, setData] = useState(initialData);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [totalPages, setTotalPages] = useState(1);
	const [totalItems, setTotalItems] = useState(0);

	const searchParams = new URLSearchParams(queryParams).toString();

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const result = await getData(`${endpoint}?${searchParams}`);
				setData(result.data);
				setTotalPages(
					Math.ceil(result.metadata.total_elements / queryParams.limit)
				);
				setTotalItems(result.metadata.total_elements);
			} catch (error) {
				setError(error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [endpoint, queryParams, currentDept]);

	return { data, loading, error, totalPages, totalItems };
};
